// extracted by mini-css-extract-plugin
export default {"container":"base-styling-options-module__container--xsuGc","tooltip":"base-styling-options-module__tooltip--t8ggZ"};